var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDevice = function SvgIconDevice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 37 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconDevice_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.332 25.5v6c0 .825-.675 1.5-1.5 1.5h-6c-.825 0-1.5-.675-1.5-1.5s.675-1.5 1.5-1.5h4.5v-3h-7.5c-4.14 0-7.5-3.36-7.5-7.5V9c0-4.14 3.36-7.5 7.5-7.5h18c4.14 0 7.5 3.36 7.5 7.5 0 .825-.675 1.5-1.5 1.5s-1.5-.675-1.5-1.5c0-2.475-2.025-4.5-4.5-4.5h-18a4.513 4.513 0 0 0-4.5 4.5v10.5c0 2.475 2.025 4.5 4.5 4.5h9c.825 0 1.5.675 1.5 1.5m18-6V30c0 3.315-2.685 6-6 6h-3c-3.315 0-6-2.685-6-6V19.5c0-3.315 2.685-6 6-6h3c3.315 0 6 2.685 6 6m-3 0c0-1.65-1.35-3-3-3h-3c-1.65 0-3 1.35-3 3V30c0 1.65 1.35 3 3 3h3c1.65 0 3-1.35 3-3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconDevice_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.332 0h36v36h-36z"
  })))));
};
export default SvgIconDevice;